import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import PageLoader from "../../../../../../components/PageLoader";
import { selectOrdersListItems } from "../../../../../../redux/orders/selector";
import { selectListItems } from "../../../../../../redux/library/selector";
import { orders } from "../../../../../../redux/orders/action";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

export const OrdersListComponent = ({
  closeModal,
  handleSelectedOrders
}: any) => {
  const dispatch = useAppDispatch();
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

  const [selectedOrders, setSelectedOrders] = useState<any>([]);
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectOrdersListItems)

  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'OrderNumber', headerName: ' Order Number', isEdit: true, searchField: 'OrderNumber', sortable: true, filter: true, filterType: 'text'
        // isGeneratedPDF: true 
      },
      { field: 'OrderPId', headerName: 'OrderPId' },
      { field: 'Name', headerName: ' Name' },
      { field: 'ProviderAccountName', headerName: 'Provider Account Name' },
      {
        field: 'OrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.OrderStatus },
        sortable: true,
        filter: false,
        isOrderEditable: true
      },
      // {
      //   field: 'FullfillmentStatusId',
      //   headerName: 'Fullfillment Status',
      //   cellRenderer: 'libraryRendererComponent',
      //   cellRendererParams: { library: libraryData?.result?.FullfillmentStatus },
      //   sortable: true,
      //   filter: false
      // },
      // {
      //   field: 'ShippingStatusId',
      //   headerName: 'Shipping Status',
      //   cellRenderer: 'libraryRendererComponent',
      //   cellRendererParams: { library: libraryData?.result?.ShippingStatus },
      //   sortable: true,
      //   filter: false,
      //   isShipmentEditable: true
      // },

      // {
      //   field: 'PaymentMethodId',
      //   headerName: 'Payment Method',
      //   cellRenderer: 'libraryRendererComponent',
      //   cellRendererParams: { library: libraryData?.result?.PaymentMethod },
      //   isRowColorDecider: true,
      //   sortable: true,
      //   filter: false
      // },
      // {
      //   field: 'PaymentStatusId',
      //   headerName: 'Payment Status',
      //   cellRenderer: 'libraryRendererComponent',
      //   cellRendererParams: { library: libraryData?.result?.PaymentStatus },
      //   isRowColorDecider: true,
      //   sortable: true,
      //   filter: false,
      //   isPaymentEditble: true
      // },
      { field: 'OrderSubtotalExclTax', headerName: 'Subtotal ExclTax', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'OrderTax', headerName: 'OrderTax', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'OrderSubtotalInclTax', headerName: 'Subtotal InclTax', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'OrderTotal', headerName: 'Total', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'IsSalesOrder', headerName: 'Sales Order', cellRenderer: 'yesNoRenderer' },
      { field: 'IsOpenNetworkOrder', headerName: 'OpenNetwork', cellRenderer: 'yesNoRenderer' },
      { field: 'StoreSalesChannelName', headerName: 'Channel Name' },
      { field: 'CreatedOnUtc', headerName: 'Created Date', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified Date', isDateValueFormat: true }
    ]);
  }

  const fetchOrdersList = () => {
    dispatch(orders.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/management/orders/list`,
      entity: 'orders',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleReloadData = () => {
    fetchOrdersList()
  }
  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "OrderNumber",
        FieldText: "OrderNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(orders.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/management/orders/list`,
      entity: 'orders',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (data: any) => {
    if (JSON.stringify(data) !== JSON.stringify(selectedOrders)) {
      setSelectedOrders(data);
    }
  }

  const onClose = () => {
    closeModal();
  }

  const handleSelectMemoized = useCallback((data: any) => {
    if (JSON.stringify(data) !== JSON.stringify(selectedOrders)) {
      setSelectedOrders(data);
    }
  }, [selectedOrders]);

  useEffect(() => {
    createColumnDefs()
    fetchOrdersList()
  }, [pageData, pageSize])

  // useEffect(() => {
  //   // console.log('itemsData', itemsData)
  // }, [itemsData]);


  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> : <></>}
      {itemsData && <>
        <div className='flex flex-col w-full'>
          <div className='flex w-full'>
            <Table columnData={columnDefs} rowData={itemsData?.result?.items[0]?.Message} setPageData={setPageData} setPageSize={setPageSize}
              paginationData={itemsData?.result?.pagination}
              onSelect={handleSelectMemoized}
              additionButtons={additionButtons} enableFilter={true} onSearch={handleSearch}
              checkboxConfig={{
                allowMultiSelect: true,
                defaultSelectedIds: [],
                isDisabled: false,
                keyColumn: 'Id',
              }}
              headingName="Orders" />
          </div>
          <div className="flex flex-row justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={()=> {handleSelectedOrders(selectedOrders), onClose()}}
              type="submit"
            >
              Create SR
            </button>
          </div>
        </div></>}
    </>
  )
}